<template>
  <Layout>
    <PageHeader :title="title" :items="braedcrumb" />
    <div>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col sm="12" md="12">
                <div>
                  <label>{{ $t("question") }}</label>
                  <b-input-group>
                    <b-form-input
                      :placeholder="$t('question')"
                      v-model="Question.question"
                      type="text"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        @click="translate('question')"
                        variant="outline-info"
                        ><i class="bx bx-globe"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </div>
              </b-col>
              <b-col class="mt-3" sm="12" md="12">
                <div>
                  <label>{{ $t("answer") }}</label>
                  <b-input-group>
                    <b-form-input
                      :placeholder="$t('answer')"
                      v-model="Question.answer"
                      type="text"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        @click="translate('answer')"
                        variant="outline-info"
                        ><i class="bx bx-globe"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-modal
        size="xl"
        :title="$t('translate')"
        v-model="translatemodal"
        no-close-on-backdrop
        hide-footer
      >
        <b-row>
          <b-col>
            <b-table
              :fields="translitefields"
              :items="translatelist"
              head-variant="primary"
              class="text-center"
              style="vertical-align:middle"
              bordered
              responsive="sm"
            >
              <template v-slot:thead-top>
                <b-tr>
                  <b-th style="width:30%">
                    <v-select
                      :options="LanguageList"
                      :reduce="(item) => item.id"
                      :placeholder="$t('ChooseBelow')"
                      label="fullname"
                      v-model="translaterow.languageid"
                    ></v-select>
                  </b-th>
                  <b-th style="width:60%">
                    <b-form-textarea v-model="translaterow.translatetext">
                    </b-form-textarea>
                  </b-th>
                  <b-th style="width:10%">
                    <b-button
                      @click="addtranslite"
                      color="primary"
                      variant="outline-primary"
                    >
                      <i class="bx bx-plus"> </i>
                    </b-button>
                  </b-th>
                </b-tr>
              </template>
              <template v-slot:cell(translatetext)="{ item }">
                <b-form-input
                  v-model="item.translatetext"
                  class="mb-0"
                ></b-form-input>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row class="m-2 mt-2">
          <b-col class="text-center">
            <b-button
              class="m-2"
              @click="translatemodal = false"
              size="sm"
              variant="outline-danger"
            >
              <i class="dripicons-arrow-thin-left"></i>
              {{ $t("back") }}
            </b-button>
            <b-button
              class="m-2"
              @click="SaveTranslate"
              size="sm"
              variant="outline-success"
            >
              <i class="dripicons-checkmark"></i>
              {{ $t("Save") }}
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col class="text-right">
                <b-button
                  @click="$router.push('/info/Question')"
                  class="d-inline-block "
                  variant="danger"
                  ><i class="dripicons-arrow-thin-left"></i>
                  {{ $t("back") }}</b-button
                >
              </b-col>
              <b-col style="text-align: right !important; " class="text-right">
                <b-button
                  @click="SaveData"
                  class="d-inline-block "
                  variant="success"
                  ><i class="dripicons-checkmark"></i>
                  {{ $t("save") }}</b-button
                >
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </Layout>
</template>
<script>
import vSelect from "vue-select";
import DatePicker from "vue2-datepicker";
import Layout from "../../../router/layouts/main.vue";
import PageHeader from "@/components/page-header";
import QuestionService from "@/services/info/Question.service";
import HelperService from "@/services/others/helper.service";
import Multiselect from "vue-multiselect";
import appConfig from "@/app.config";
export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Multiselect,
    Layout,
    PageHeader,
    DatePicker,
    vSelect,
  },
  data() {
    return {
      title: this.$t("Question"),
      braedcrumb: [
        {
          text: this.$t("Info"),
        },
        {
          text: this.$t("Question"),
          active: true,
        },
      ],
      items: [],
      Question: { TranslatableColumns: [] },
      isLoading: false,
      translatemodal: false,
      fields: [
        {
          key: "text",
          label: this.$t("text"),
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "actions",
          label: this.$t("actions"),
          thClass: "text-center",
          sortable: true,
        },
      ],
      translitefields: [
        {
          key: "languagename",
          label: this.$t("languagename"),
          variant: "info",
        },
        { key: "translatetext", label: this.$t("name"), variant: "info" },
        { key: "actions", label: "", variant: "info" },
      ],
      translatelist: [],
      translaterow: {
        tableid: 0,
        tablerowid: 0,
        languageid: 0,
        languagename: "",
        columnname: "",
        translatetext: "",
      },
      translatebyname: "",

      QuestionList: [],
      LanguageList: [],
      editedIndex1: -1,
      lang: "ru",
    };
  },
  created() {
    this.lang = localStorage.getItem("locale") || "ru";
    this.show = true;
    HelperService.GetListLanguages().then((res) => {
      this.LanguageList = res.data;
    });
    QuestionService.Get(this.$route.params.id)
      .then((res) => {
        this.show = false;
        this.Question = res.data;
        this.translatelist = res.data.Translates;
        // this.Question.parentid = null;
      })
      .catch((error) => {
        this.$notification(error.response.data.error, "danger");
      });
  },
  directives: {},
  methods: {
    OpenQuestionModal() {
      this.QuestionModal = true;
    },
    translate(selectcolumnname) {
      var self = this;
      self.translatebyname = selectcolumnname;
      self.translatelist = self.Question.Translates.filter(
        (item) => item.columnname == selectcolumnname
      );
      self.translatemodal = true;
    },
    addtranslite() {
      var self = this;
      if (
        self.translaterow.languageid === 0 ||
        self.translaterow.languageid === undefined ||
        self.translaterow.languageid === null
      ) {
        this.$notification(
          this.$t("languageidNotSelect"),
          this.$t("Error"),
          "danger"
        );
      } else if (
        self.translaterow.translatetext === "" ||
        self.translaterow.translatetext === undefined ||
        self.translaterow.translatetext === null
      ) {
        this.$notification(
          this.$t("translatetextNotSelect"),
          this.$t("Error"),
          "danger"
        );
      } else {
        var dublikate = false;
        self.translatelist.forEach((item) => {
          if (item.languageid === self.translaterow.languageid) {
            this.$notification(
              this.$t("dublikate"),
              this.$t("Error"),
              "danger"
            );
            dublikate = true;
          }
        });
        if (!dublikate) {
          self.translaterow.languagename = self.LanguageList.filter(
            (item) => item.id === self.translaterow.languageid
          )[0].fullname;
          self.translaterow.columnname = self.translatebyname;
          self.translatelist.push(self.translaterow);
          self.translaterow = {
            tableid: 0,
            tablerowid: 0,
            languageid: 0,
            languagename: "",
            columnname: "",
            translatetext: "",
          };
        }
      }
    },
    SaveTranslate() {
      var self = this;
      self.Question.Translates = self.Question.Translates.filter(
        (x) => x.columnname !== self.translatebyname
      );
      self.translatelist.forEach((item) => {
        self.Question.Translates.push(item);
      });
      self.translatemodal = false;
    },
    rowClass(item, type) {
      if (item.Status === 3) return "d-none";
    },
    Edit(item) {
      if (item.Status == 0) {
        item.Status = 2;
      }
      this.editedIndex1 = this.Question.Tables.indexOf(item);
      this.tabrow = Object.assign({}, item);
      this.ModalShow = true;
    },
    DeleteRow(item) {
      item.Status = 3;
    },
    AddRow() {
      if (this.editedIndex1 > -1) {
        Object.assign(this.Question.Tables[this.editedIndex1], this.tabrow);
      } else {
        this.Question.Tables.push(this.tabrow);
      }
      this.ModalShow = false;
    },
    OpenModal() {
      this.ModalShow = true;
      this.tabrow = {
        id: 0,
        ownerid: 0,
        text: "",
        Status: 1,
      };
      this.editedIndex1 = -1;
    },
    check() {
      if (
        this.Question.question === 0 ||
        this.Question.question === null ||
        this.Question.question === undefined ||
        this.Question.question === ""
      ) {
        this.$notification(this.$t("questionNotSelected"), "danger");
        return false;
      }
      if (
        this.Question.answer === 0 ||
        this.Question.answer === null ||
        this.Question.answer === undefined ||
        this.Question.answer === ""
      ) {
        this.$notification(this.$t("stateNotSelected"), "danger");
        return false;
      }

      return true;
    },
    SaveData() {
      //   console.log(this.Question);
      //   if (!this.check()) {
      //     return false;
      //   }
      QuestionService.Update(this.Question)
        .then((res) => {
          this.$notification(this.$t("SaveSuccess"), "success");
          this.$router.push({ name: `Question` });
        })
        .catch((err) => {
          this.$notification(this.$t(err.response.data.error), "danger");
        });
    },
  },
};
</script>

<style></style>
